export default __webpack_public_path__ + "static/drill-5e50d447372e3253479dba52de562d6a.png";